<template>
  <div class="manage-field pt-3">
    <div v-if="loading" class="loading-div">
      <v-progress-circular
        class="loading-icon"
        indeterminate
        color="primary"
      />
    </div>
    <Dialog
      :dialog.sync="deleteCropDialog.show"
      :cardText="deleteCropDialog.cardText"
      :mainBtnText="deleteCropDialog.mainBtnText"
      :secondaryBtnText="deleteCropDialog.secondaryBtnText"
      :alertColor="true"
      @mainBtnCallback="deleteCrop"
    />
    <v-dialog
      v-if="deviceNamesDialog.show"
      v-model="deviceNamesDialog.show"
      width="500"
      content-class="device-detail-dialog"
    >
      <v-card>
        <v-card-title class="text-h5 lighten-2 text-break">
          {{ $t('ManageField.assignedDevices') }}
        </v-card-title>
        <v-card-text>
          <template v-if="deviceNamesDialog.names.length">
            <p class="mb-0" style="color: #000000DE" v-for="name in deviceNamesDialog.names" :key="name">{{ name }}</p>
          </template>
          <p v-else>{{ $t('ManageField.noAssignedDevices') }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container class="pt-5 px-0" v-if="field">
        <h3 class="header-field pt-3"><a class="path-link-text" @click="goToOrganizationHome">{{ $t('ManageField.dashboard') }}</a> / {{field.name}}</h3>
        <v-divider></v-divider>

        <v-row class="section-header pt-5">
          <p class="section-title">{{$t('ManageField.crops')}}</p>
          <a @click="addCrop" class="add-elem-btn px-5">+ {{$t('ManageField.addCrop')}}</a>
        </v-row>
        <v-layout row wrap class="crops-list">
          <template v-if="crops.length">
            <v-flex v-for="crop in crops" :key="crop.id" xs12 sm6 md3 class="px-3 py-3">
              <v-card class="crop-card" @click="editCrop(crop)">
                <v-card-title>
                  <v-layout>
                    <v-flex xs2>
                      <v-img :src="require('@/assets/min-lot.png')"/>
                    </v-flex>
                    <v-flex xs8 class="px-1">
                      <p class="crop-header-title ma-0">{{crop.name}}</p>
                      <p class="crop-header-subtitle ma-0">{{crop.area}} ha</p>
                      <p class="crop-header-subtitle ma-0">{{(crop.field && crop.field.name) || '-'}}</p>
                      <p class="crop-header-subtitle ma-0 crop-devices-clickable" @click.stop="openDeviceNamesDialog(crop)">{{ crop.devices && crop.devices.length == 1 ? $t('ManageField.cropDeviceQty', {devices: 1}) : $t('ManageField.cropDevicesQty', {devices: !crop.devices ? 0 : crop.devices.length}) }}</p>
                    </v-flex>
                    <v-flex xs2>
                      <v-menu offset-y left>
                        <template v-slot:activator="{ on }">
                          <v-btn class="menu-btn" dark text icon color="#00202F" v-on="on">
                            <v-icon>more_horiz</v-icon>
                          </v-btn>
                        </template>
                        <v-list class="pa-0">
                          <v-list-item @click="deleteCropHandler(crop, crop.device)">
                            <v-list-item-title style="color: #F93A2F">{{$t('ManageField.delete')}}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-card-title>
              </v-card>
            </v-flex>
          </template>
          <div class="empty-div" v-else>
            <p class="empty-list-text mt-1 mb-0">{{$t('ManageField.emptyCrops')}}</p>
          </div>
        </v-layout>
    </v-container>
  </div>
</template>

<script>
import { EVENTS_TO_TRACK } from '../../constants/const'
import {deleteCrop} from '../../lib/crudOperations/delete'
import { trackEvent } from '../../lib/track-events'
import Dialog from '../Shared/Dialog.vue'
export default {
  data () {
    return {
      deleteCropDialog: {
        show: false,
        cardText: '',
        mainBtnText: this.$t('ManageField.deleteCropMainBtnText'),
        secondaryBtnText: this.$t('ManageField.deleteCropSecondaryBtnText'),
        cropId: ''
      },
      field: this.$route.params.field,
      loading: false,
      deviceNamesDialog: {
        show: false,
        names: []
      }
    }
  },
  created () {
    if (!this.field) {
      this.$router.push('/organizationHome')
    }
  },
  computed: {
    crops () {
      return this.$store.getters.crops.filter(crop => crop.field === this.field.id).sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  methods: {
    addCrop () {
      this.$router.push({name: 'AddCrop', params: {isNewCrop: true, crop: {field: this.field.id}}})
    },
    editCrop (crop, devId) {
      if (devId) crop.device = devId
      this.$router.push({name: 'AddCrop', params: {isNewCrop: false, crop}})
    },
    deleteCropHandler (crop) {
      this.deleteCropDialog.cardText = this.$t('OrganizationData.deleteCropCardText', [crop.name])
      this.deleteCropDialog.show = true
      this.deleteCropDialog.cropId = crop.id
    },
    async deleteCrop () {
      try {
        this.loading = true
        await deleteCrop(this.deleteCropDialog.cropId)
        this.$root.snack.show({text: this.$t('UI.deleteSuccess')})
      } catch (err) {
        this.$root.snack.show({text: this.$t('UI.deleteError'), error: true})
      } finally {
        this.loading = false
      }
    },
    goToOrganizationHome () {
      trackEvent(EVENTS_TO_TRACK.CLICK_GO_TO_ORGANIZATION_HOME_FROM_FIELD_BUTTON)
      this.$router.push('OrganizationHome')
    },
    getCropDeviceNames (crop) {
      if (!crop.devices || !crop.devices.length) return []
      const devices = this.$store.getters.devices || []
      return crop.devices
        .map(deviceId => {
          const device = devices.find(d => d.id === deviceId)
          return device && device.campaign && device.campaign.entityName ? device.campaign.entityName : deviceId
        })
        .filter(Boolean)
    },
    openDeviceNamesDialog (crop) {
      this.deviceNamesDialog.names = this.getCropDeviceNames(crop)
      this.deviceNamesDialog.show = true
    }
  },
  components: {
    Dialog
  }
}
</script>

<style scoped>
.crop-devices-clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ManageField.vue?b68b34d8